<template>
  <div class="toggle"
       :class="{'--active':checked}"
       @click="click">
    <div class="toggle-box">
      <div class="toggle-off">
        {{ textOff }}
      </div>
      <div class="toggle-on">
        {{ textOn }}
      </div>
      <div class="toggle-indicator"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToggleWText",
  props: {
    textOff: {type: String, default: 'Выкл'},
    textOn: {type: String, default: 'Вкл'},
    checked: {type: Boolean, required: true}
  },
  methods: {
    click() {
      this.$emit('change', !this.checked);
    }
  }
}
</script>

<style scoped lang="scss">
.toggle {
  position: relative;
  width: 100%;
  height: 30px;
  @apply flex items-center cursor-pointer overflow-hidden;
  border-radius: 36.5px;

  .toggle-box {
    @apply bg-border flex transition duration-200 w-full overflow-hidden;
    padding: 2px;
  }

  .toggle-off, .toggle-on {
    @apply absolute w-full h-full flex items-center inset-0 text-sm;
  }

  .toggle-off {
    @apply pl-16 text-text-muted;
  }

  .toggle-on {
    @apply opacity-0 bg-green-toggle text-white justify-center;
  }

  .toggle-indicator {
    @apply bg-white rounded-full transition duration-200 ml-0 z-60;
    width: 26px;
    height: 26px;
    transition: all .2s;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.01), 0px 3px 1px rgba(0, 0, 0, 0.03);
  }

  &.--active {
    .toggle-box {
      @apply bg-green;
    }

    .toggle-on {
      @apply opacity-100;
    }

    .toggle-indicator {
      @apply ml-auto;
    }
  }
}
</style>